<template>

<div ref="trapRef" class="programme-overview-modal" v-if="programmeOverview === true">
      <q-card class="pa ">
        <q-card-section class="row items-center q-pb-none ">
       
        <div class="modal-title-icon">
          <q-btn class="q-mb-lg" @click="programmeOverview = false" icon="close" flat round dense v-close-popup />
        </div>
        </q-card-section>
            
        <q-card-section class="">

          <section>
            <section class="relative ">
              
              <div class="container">
                
                <div class="narrow-text ">
                  
                  <h2 class="q-ml-lg">Programme overview</h2>
          
            <q-timeline class="mts container timeline-black " :layout="layout" side="right" color="black">
              <q-timeline-entry
                title="Arrival (tea, coffee, pastries/fruit)"
                subtitle="9:00 - 9:30am"
                icon="coffee"
                side="right"
              >

              <div>Business School, Ground Floor South Atrium (top end)</div>
              
              </q-timeline-entry>

              <q-timeline-entry
                title="Welcome"
                subtitle="9:30 - 9:45am"
                icon="schedule"
                side="right"
              >

              <div>BS G.26 Lecture Theatre</div>

              <div></div>
              </q-timeline-entry>
              <q-timeline-entry
                title="Parallel sessions (A - H): Interactive presentations"
                subtitle="10:00 - 11:15am"
                side="right"
                icon="schedule"
              >

              <div>BS3.20 - BS3.27</div>

              </q-timeline-entry>

              <q-timeline-entry
                title="Morning Break (tea, coffee, biscuits)"
                subtitle="11:15 - 11:45am"
                icon="coffee"
                side="right"
              >

              <div class="">Ground Floor North Atrium</div>
              </q-timeline-entry>
              <q-timeline-entry
              title="Parallel sessions (I - R): Lightning presentations, workshops and round table discussion"
              subtitle="11:45 - 12:45pm"
              icon="schedule"
              side="right"
              >
              <div>BS3.14 - BS3.18 + BS3.24 - BS3.28</div>
              </q-timeline-entry>
              <q-timeline-entry
                title="Lunch"
                subtitle="12:45 - 1:45pm"
                icon="restaurant"
                side="right"
              >
              <div class="">Ground Floor North Atrium</div>
              </q-timeline-entry>
              <q-timeline-entry
                title="Keynote: Professor Paul Ashwin, Lancaster University"
                subtitle="1:45 - 2:30pm"
                icon="account_circle"
                side="right"
              >
              <div class="">BS G.26 Lecture Theatre</div>
          
              </q-timeline-entry>
              <q-timeline-entry
                title="Parallel sessions (S - Z): Interactive presentations (tea/coffee)"
                subtitle="2:45 - 4:00pm"
                icon="schedule"
                side="right"
              >
              <div class=""><div>BS3.20 - BS3.27</div></div>
              <div class=""></div>
              </q-timeline-entry>
              <q-timeline-entry
                title="Drinks Reception"
                subtitle="4:00 - 4:30pm"
                icon="chat"
                side="right"
              >
              <div class="">Ground Floor North Atrium</div>
              </q-timeline-entry>
          
            </q-timeline>
      
        </div>
      </div>
      
    </section>
</section>

        </q-card-section>
      </q-card>
    </div>

    <div v-if="programmeOverview === true" @click="programmeOverview = false" class="modal-background"></div>

    <q-btn class="overview-button" @click="programmeOverview = !programmeOverview" no-caps color="primary">
      <q-icon left size="2em" name="map" />
      <div>Programme overview</div>
    </q-btn>


    <section class="yellow-background relative">
        <div class="container section-small">
            <h2>Conference programme</h2>
        </div>
        <div class="programme-divider">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" class="shape-fill"></path>
            </svg>
        </div> 
    </section>

    <section class="filter container mtl">

      <h3>Filter options</h3>

      <div class="search-bar">
          <q-input
                class="searchBarProgramme"
                @keydown.enter="searchSessions"
                v-model="search"
                filled
                placeholder="Search for session titles 🌞, lead presenters 👳🏽‍♂️, and co-contributors 👩🏼‍🦳👨‍🦰👩🏿‍🦱" >
                  <template v-slot:prepend>
                    <q-icon name="search" />
                  </template>
          </q-input>
          <q-btn size="md" class="q-mt-md q-mr-md" no-caps color="primary" @click="searchSessions">Search</q-btn>
          <q-btn size="md" class="q-mt-md" no-caps  outline @click="searchFilter = false ; search = '' ; openAccordians = false">Clear</q-btn>
      </div>

      <div class="filter_options">
      <q-select
          class="mts searchBarProgramme"
          filled
          use-chips
          v-model="themes"
          @update:model-value="searchFilter = false ; themesQuery() ; filterHandler()"
          multiple
          :options="themeOptions"
          label="Themes"
          style="width: 250px"
          map-options
          emit-value
          options-cover
      />

      <q-select
          class="mts searchBarProgramme"
          filled
          options-cover
          use-chips
          v-model="sessionFormat"
          @update:model-value="searchFilter = false ; sessionFormatQuery() ; filterHandler()"
          multiple
          :options="sessionFormatOptions"
          label="Session formats"
          style="width: 250px"
          map-options
      />

      <q-select
          class="mts searchBarProgramme"
          filled
          options-cover
          use-chips
          v-model="timeRangeArry[0]" 
          @update:model-value="searchFilter = false ; sessionTimeQuery() ; filterHandler()"
          :options="sessionStartTimeOptions"
          label="Start time"
          style="width: 250px"
          map-options
      />

      <q-select
          class="mts searchBarProgramme"
          filled
          options-cover
          use-chips
          v-model="timeRangeArry[1]" 
          @update:model-value="searchFilter = false ; sessionTimeQuery() ; filterHandler()"
          :options="sessionEndTimeOptions"
          label="End time"
          style="width: 250px"
          map-options
      />

      </div>
             <q-btn size="md" class="q-mt-sm" no-caps  outline @click="themes = [] ; sessionFormat = [] ; queries = {} ; timeRangeArry = ['10:00','16:00'] ; filterHandler(); openAccordians = false ">Reset</q-btn>
    </section>

    <div class="container spinner" v-if="loading === true" >
      <q-spinner-clock class="spinner-icon" color="primary" />
        <q-tooltip :offset="[0, 8]">Loading</q-tooltip>
    </div>
    
    <SessionCards @apiSwap="seshFilter" v-if="searchFilter === false"  :key="route.params" :openAccordians="openAccordians" :search="search" /> 
    
    <Card v-else :sessions="sessions" :search="search" :openAccordians="openAccordians" />

</template>

<script setup>

    import { ref, watch } from "vue"
    import { useRoute, useRouter } from "vue-router"
    import SessionCards from "@/components/SessionCards.vue"
    import SessionCardSkeleton from "../components/SessionCardSkeleton.vue"
    import useFocusTrap from "../composables/useFocusTrap"
    import Card from "../components/Card.vue"
    import axios from "axios"

    const route = useRoute()
    const { trapRef } = useFocusTrap();
    const router = useRouter()
    const loading = ref(false)
    const search = ref('')
    const searchFilter = ref(false)
    const programmeOverview = ref(false)

    ///FILTER OPTIONS
    const timeRangeArry = ref(['10:00','16:00'])
    const themes = ref([])
    const sessionFormat = ref([])
    const queries = ref({})
    const sessions = ref([])
    const sessionFacilitators = ref([])

    let openAccordians = ref(false) 
    
    const sessionFormatOptions = ref(['Interactive presentation', 'Workshop', 'Lightning presentation', 'Round table discussion'])
    
    const themeOptions = ref(['Active learning for student engagement', 'Bringing inclusive learning and curricula to life', 'Authentic learning and assessment', 'Creative and innovative pedagogies', 'Supporting student futures and careers', 'Education for Sustainable Development (ESD) and carbon literacy'])
    
    const sessionStartTimeOptions = ref(['10:00', '11:45', '14:45'])
    const sessionEndTimeOptions = ref(['11:15', '12:45', '16:00'])
    
    const seshFilter = () => {
      openAccordians.value = false
      searchFilter.value = false
      console.log('seshFilter',  openAccordians.value, searchFilter.value)
    }

    const themesQuery = () => {
        const myKey = "filter[themes]"
        queries.value[myKey] = themes.value.slice(',').join(',').toString()
        queries.value[myKey].length === 0 ? delete queries.value[myKey] : queries.value
    }

    const sessionFormatQuery = () => {
        const myKey = "filter[session_type]"
        queries.value[myKey] = sessionFormat.value.slice(',').join(',').toString()
        queries.value[myKey].length === 0 ? delete queries.value[myKey] : queries.value
    }

    const sessionTimeQuery = () => {
      const myKey = "filter[time_range]"
      queries.value[myKey] = timeRangeArry.value.slice(',').join(',').toString()
      queries.value[myKey].length === 0 ? delete queries.value[myKey] : queries.value
      // filterHandler()
    }

    ///DATABASE RESULTS
  
    const queryString = route.fullPath.split('/programme')[1]

    const searchSessions = async () => {

      try {
      loading.value = true
      openAccordians.value = true 
      searchFilter.value = true
      // const response = await axios.get(`http://127.0.0.1:8000/api/search/${search.value}`)
      const response = await axios.get(`https://www.utaresources.mmu.ac.uk/leed-conference-23/server/public/api/search/${search.value}`)
      sessions.value = response.data
      loading.value = false
    } catch (error) {
      loading.value = false
    }

    loading.value = false

      if(!search.value) {
        searchFilter.value = false
      }
    }

    const filterHandler = () => {
        router.push({name: 'Programme', query: queries.value})
    } 

    const eventHandler = async (link) => {
      await router.push({path: '/'})
      document.getElementById(link).scrollIntoView({behavior: "smooth"})
    }

    document.body.scrollTo({
      top: 0,
      left: 100,
      behavior: "instant",
    })

</script>

<style>



.overview-button {
  position: fixed;
  top: 98%;
  left: 98%;
  transform: translate(-98%, -98%);
  z-index: 100;
  line-height: 2.4rem;
}

.modal-background {
  height: 105%;
  cursor: pointer;
}



</style>